<template>
  <div class="db-tw-relative">
    <div
      v-if="$slots.stepper"
      class="md:db-tw-absolute md:db-tw-top-0 md:db-tw-left-0 md:db-tw-w-1/5 md:db-tw-m-0"
    >
      <!-- @slot Contains the stepper -->
      <slot name="stepper" />
    </div>
    <div class="db-tw-my-10 md:db-tw-w-1/2 md:db-tw-my-0 md:db-tw-mx-auto">
      <!-- @slot Contains the current step of the form -->
      <slot name="form" />
    </div>
  </div>
</template>
